import {
  useMediaQuery as MuiUseMediaQuery,
  UseMediaQueryOptions as MuiUseMediaQueryOptions,
  Theme
} from '@mui/material';

export const useMediaQuery = (mediaQuery: (theme: Theme) => string, options?: MuiUseMediaQueryOptions) =>
  MuiUseMediaQuery(mediaQuery, options);
